import type {FC} from 'react'
import templatesData from '../../data/sales/salesTemplatesData'
import CombinedWorkflow from '../universal-components/combined-workflow/CombinedWorkflow'

interface SalesPageProps {}

const SalesPage: FC<SalesPageProps> = () => {
  const title = 'Sales'
  const buttonColor = 'var(--sales-workflow-btn-color)'
  return <CombinedWorkflow title={title} buttonColor={buttonColor} itemsData={templatesData} />
}

export default SalesPage
